const baseURL = 'https://dev-portal-cliente.azurewebsites.net';

const apiVersion = 'v1';
const url = `${baseURL}/api/${apiVersion}`;
const hubUrl = `${baseURL}/hubs/chat`;

export const environment = {
  production: true,
  development: false,

  url,
  hubUrl,
};
